import React, { ChangeEvent, useCallback, MouseEvent, CSSProperties, FC, KeyboardEvent } from 'react';
import cn from 'classnames';
import { Keys as KeysKeyboard } from '../../../lib/keyboard';
import Indent from './Indent';
import { Checkbox } from '../../Checkbox';
import { TreeNode } from '../Tree.heplers';
require("./TreeItem.css");
var styles = {
  "Root": "TreeItem-module-Root_Ese",
  "Content": "TreeItem-module-Content_16Z",
  "Label": "TreeItem-module-Label_mYU",
  "checked": "TreeItem-module-checked_-sW",
  "Icon": "TreeItem-module-Icon_3_C"
};
export const TreeItem = ({
  node,
  onChecked,
  onNodeExpand,
  isChecked,
  checkable,
  itemClassName,
  itemStyle,
  setFocusToItem,
  roleTreeItem = 'treeitem'
}) => {
  const {
    title,
    level,
    disableCheckbox
  } = node.value;
  const onExpand = useCallback(event => {
    if (node.isLeaf) return;
    onNodeExpand(event, node);
  }, [node, onNodeExpand]);
  const onChange = useCallback(event => {
    onChecked(event, node);
  }, [node, onChecked]);
  const onKeydown = useCallback(event => {
    // флаг используется для прерывания евента по листу или переключение на след элемент с помощью табуляции
    let flag = false;
    if (event.altKey || event.ctrlKey || event.metaKey) {
      return;
    }
    switch (event.key) {
      case KeysKeyboard.ENTER:
      case KeysKeyboard.RETURN:
        if (!node.isLeaf) {
          onExpand(event);
        }
        flag = true;
        break;
      case KeysKeyboard.UP:
        setFocusToItem(node);
        flag = true;
        break;
      case KeysKeyboard.DOWN:
        setFocusToItem(node, 'down');
        flag = true;
        break;
      case KeysKeyboard.RIGHT:
        if (node.isLeaf || node.expanded) {
          setFocusToItem(node, 'down');
        } else {
          onExpand(event);
        }
        flag = true;
        break;
      case KeysKeyboard.LEFT:
        if (node.expanded && !node.isLeaf) {
          onExpand(event);
        } else {
          setFocusToItem(node, 'up');
        }
        flag = true;
        break;
    }
    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, [onExpand, node, setFocusToItem]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, itemClassName),
    style: itemStyle,
    role: roleTreeItem,
    "aria-expanded": node.isLeaf ? undefined : node.expanded,
    tabIndex: node.tabindex,
    onKeyDown: onKeydown,
    ref: node.ref
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Content, {
      [styles.checked]: isChecked
    })
  }, /*#__PURE__*/React.createElement(Indent, {
    level: level
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.Icon,
    onClick: onExpand
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.Label
  }, title)), checkable && /*#__PURE__*/React.createElement(Checkbox, {
    checked: isChecked,
    disabled: disableCheckbox,
    name: String(node.key),
    onChange: onChange,
    tabIndex: node.tabindex
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TreeItem.displayName = 'TreeItem';
}